import { ReactComponent as SkontoLogo } from '../../../../icons/skonto-product-icon.svg';
import { ReactComponent as NanoFactoring } from '../../../../icons/nano-factoring-product-icon.svg';
import { ReactComponent as PurchaseFinance } from '../../../../icons/purchase-finance-product-icon.svg';
import { ReactComponent as DeferredPayment } from '../../../../icons/deferred-payment-product-icon_2.svg';
import { ReactComponent as PragmaPay } from '../../../../icons/pragma-pay-product-icon.svg';

export const mapProductToLogo = (product) => {
  const mapper = {
    SKONTO: SkontoLogo,
    NANO: NanoFactoring,
    PURCHASE_FINANCE: PurchaseFinance,
    DEFERRED_PAYMENT: DeferredPayment,
    PRAGMA_PAY: PragmaPay,
  };

  return mapper[product] || null;
};

export const slugify = (str) => {
  str = str.replace(/^\s+|\s+$/g, ''); // trim leading/trailing white space
  str = str.toLowerCase(); // convert string to lowercase
  str = str
    .replace(/[^a-z0-9 -]/g, '') // remove any non-alphanumeric characters
    .replace(/\s+/g, '-') // replace spaces with hyphens
    .replace(/-+/g, '-'); // remove consecutive hyphens
  return str;
};

export const setProductsArray = (products, formatMessage) => {
  const data = products?.data.map(({ name, translation }) => ({
    name: translation,
    description:
      name === 'PRAGMA_PAY' ? formatMessage({ id: 'PragmaPay description' }) : <span style={{ height: '20px', display: 'block' }}></span>,
    product: name,
    logo: mapProductToLogo(name),
  }));

  return data;
};
